module.exports = __webpack_public_path__ + "static/img/zuhe.d6af5cf.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/newCourse/zuhe.png
// module id = F3zU
// module chunks = 96